import * as React from "react";

import BettingBoard from "./BettingBoard";
import InfoBoxesHolder from "../Common/InfoBox/InfoBoxesHolder";
import { useAppSelector } from "../../store/hooks";

const BettingPanel: React.FC = () => {
  const isDesktopScreen = useAppSelector(
    (state) => state.config.isDesktopScreen
  );

  return (
    <main id="top" className={`${isDesktopScreen ? "shellPanel" : ""}`}>
      <InfoBoxesHolder showHistory />

      <BettingBoard />
    </main>
  );
};

export default BettingPanel;
